import React from "react";
import { useTranslation } from "react-i18next";
import BrandNav from "../../components/BrandNav";

export default function RoboticsHeritage() {
  const { t } = useTranslation();
  return (
    <>
      <BrandNav />
      <main className="ftg-page">
        <h1>{t("robotics.heritage_title")}</h1>
        <p>{t("robotics.heritage_subtitle")}</p>
      </main>
    </>
  );
}
